import Dialog from "../1. Core/Controls/Dialog/Dialog";

import Select from "../1. Core/Controls/Select/Select";
import NP from "../1. Core/NP";
import Label from "../1. Core/Controls/Label/Label";
import './BoxJudgePointsInputDialog.scss';
import NumField from "../1. Core/Controls/TextField/NumField";
import {IJudge} from "./JudgesList";
import {ServerAPI} from "../1. Core/ServerAPI";
import {IBattle} from "../10. Battle/types";


/**
 * Диалог ввода оценок от судей по боксу за бой
 */
export default class BoxJudgePointsInputDialog extends Dialog {
	private _Battle: IBattle;
	private _judgesCombo: Select[];
	private _redInputs: NumField[];
	private _blueInputs: NumField[];
	private _redLbl: Label;
	private _blueLbl: Label;


	_initFields(settings: object)
	{
		this._Battle = null;
		super._initFields(settings);
		this._Width = 950;
		this._Height = 400;
		this._ShowHeader = true;
		this._Caption = NP.RM.getString('JudgePoints');
	}

	_render()
	{
		super._render();

		this.addClass('judge-points-input-dialog');

		this._judgesCombo = [];
		this._redInputs = [];
		this._blueInputs = [];

		for (let i = 0; i < 5; i++)
			this._judgesCombo.push(new Select({
				ParentNode: this._contentNode,
				Width: 140,
				FloatingLabel: NP.RM.getString('Judge') + "" + (i + 1)
			}));


		let row1 = NP.createNode(this._contentNode, 'row1');
		this._redLbl = new Label({
			ParentNode: row1,
			Width: 125,
			Class: 'red',
			Content: NP.escapeHTML(this._Battle.RedName)
		});
		for (let i = 0; i < 5; i++)
			this._redInputs.push(new NumField({
				ParentNode: row1,
				Min: 6,
				Max: 30,
				Width: 140
			}));


		let row2 = NP.createNode(this._contentNode, 'row2');
		this._blueLbl = new Label({
			ParentNode: row2,
			Width: 125,
			Class: 'blue',
			Content: NP.escapeHTML(this._Battle.BlueName)
		});

		for (let i = 0; i < 5; i++)
			this._blueInputs.push(new NumField({
				ParentNode: row2,
				Min: 6,
				Max: 30,
				Width: 140
			}));


		ServerAPI.post("/judge/items", {}).then((judges: IJudge[]) =>
		{
			if (judges)
			{
				this._judgesCombo.forEach(combo => combo.setItems(judges.map(el => ({
						 Content: (el.LastName + ' ' + (el.FirstName ? el.FirstName : '')).trim(),
						 Value: el.Id
					 })
				)));
			}
			this.loadPoints();
		});
	}

	loadPoints()
	{
		ServerAPI.get(`/judge/getJudgePoints/${this._Battle.Id}`).then((points: JudgePoint[]) =>
		{
			if (points && points.length)
			{
				let redPoints = points.filter(p => p.AthleteId == this._Battle.Red),
					 bluePoints = points.filter(p => p.AthleteId == this._Battle.Blue);

				for (let i = 0; i < 5; i++)
				{
					this._judgesCombo[i].setValue(redPoints[i].JudgeId);
					this._redInputs[i].setValue(redPoints[i].Value);
					this._blueInputs[i].setValue(bluePoints[i].Value);
				}
			}
		});
	}

	_onOkButtonClick()
	{
		let judjes = this._judgesCombo.map(select => select.getValue());

		let res = [] as JudgePoint[];

		let uniqJKeys = {} as any;

		for (let i = 0; i < 5; i++)
		{
			if (!judjes[i])
				return NP.showMessage({RK: 'SelectJudges'});

			if (uniqJKeys[judjes[i]] == true)
				return NP.showMessage({RK: 'JudgesMustBeUniq'});

			uniqJKeys[judjes[i]] = true;

			res.push({
				JudgeId: judjes[i],
				AthleteId: this._Battle.Red,
				Value: this._redInputs[i].getValue()
			});

			res.push({
				JudgeId: judjes[i],
				AthleteId: this._Battle.Blue,
				Value: this._blueInputs[i].getValue()
			});
		}

		ServerAPI.post(`/judge/addJudgePoints/${this._Battle.Id}`, res).then(() => this.hide());
	}
}

type JudgePoint = {
	JudgeId: number;
	AthleteId: number;
	Value: number;
};